import { render, staticRenderFns } from "./OphthalmicSystem.vue?vue&type=template&id=723d2051&scoped=true&"
import script from "./OphthalmicSystem.vue?vue&type=script&lang=js&"
export * from "./OphthalmicSystem.vue?vue&type=script&lang=js&"
import style0 from "./OphthalmicSystem.vue?vue&type=style&index=0&id=723d2051&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "723d2051",
  null
  
)

export default component.exports